import { z } from 'zod';


// #/components/schemas/markersOfHarmMohInteractionType
export const MarkersOfHarmMohInteractionTypeZod = z.union([z.literal('email'), z.literal('phone-call'), z.literal('pop-up'), z.literal('live-chat'), z.literal('social-media'), z.literal('whats-app'), z.literal('other')]);
export type MarkersOfHarmMohInteractionTypeType = z.TypeOf<typeof MarkersOfHarmMohInteractionTypeZod>;


// #/components/schemas/markersOfHarmMohRiskLevel
export const MarkersOfHarmMohRiskLevelZod = z.union([z.literal('none'), z.literal('very-low'), z.literal('low'), z.literal('medium'), z.literal('high'), z.literal('very-high')]);
export type MarkersOfHarmMohRiskLevelType = z.TypeOf<typeof MarkersOfHarmMohRiskLevelZod>;


// #/components/schemas/markersOfHarmMohInteractionStatus
export const MarkersOfHarmMohInteractionStatusZod = z.union([z.literal('successful'), z.literal('unsuccessful')]);
export type MarkersOfHarmMohInteractionStatusType = z.TypeOf<typeof MarkersOfHarmMohInteractionStatusZod>;


// #/components/schemas/markersOfHarmExtendedMohData
export const MarkersOfHarmExtendedMohDataZod = z.object({
    mohId: z.number(),
    accountId: z.string(),
    universe: z.string(),
    interactionType: MarkersOfHarmMohInteractionTypeZod,
    interactionTimestamp: z.string(),
    nextReviewTimestamp: z.string().optional(),
    note: z.string().optional(),
    reason: z.string(),
    riskLevel: MarkersOfHarmMohRiskLevelZod,
    interactionStatus: MarkersOfHarmMohInteractionStatusZod,
    profitLoss: z.string().optional(),
    agent: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export type MarkersOfHarmExtendedMohDataType = z.TypeOf<typeof MarkersOfHarmExtendedMohDataZod>;


// #/components/schemas/markersOfHarmMohListResponse
export const MarkersOfHarmMohListResponseZod = z.object({
    interactions: z.array(MarkersOfHarmExtendedMohDataZod),
});
export type MarkersOfHarmMohListResponseType = z.TypeOf<typeof MarkersOfHarmMohListResponseZod>;


// #/components/schemas/markersOfHarmMohCreateRequest
export const MarkersOfHarmMohCreateRequestZod = z.object({
    accountId: z.string(),
    universe: z.string(),
    interactionType: MarkersOfHarmMohInteractionTypeZod,
    interactionTimestamp: z.string(),
    nextReviewTimestamp: z.string().optional(),
    note: z.string().optional(),
    reason: z.string(),
    profitLoss: z.string(),
    riskLevel: MarkersOfHarmMohRiskLevelZod,
    interactionStatus: MarkersOfHarmMohInteractionStatusZod,
    agent: z.string(),
});
export type MarkersOfHarmMohCreateRequestType = z.TypeOf<typeof MarkersOfHarmMohCreateRequestZod>;


// #/components/schemas/markersOfHarmMohUpdateRequest
export const MarkersOfHarmMohUpdateRequestZod = z.object({
    accountId: z.string(),
    universe: z.string(),
    interactionType: MarkersOfHarmMohInteractionTypeZod.optional(),
    nextReviewTimestamp: z.string().optional(),
    note: z.string().optional(),
    reason: z.string().optional(),
    riskLevel: MarkersOfHarmMohRiskLevelZod.optional(),
    interactionStatus: MarkersOfHarmMohInteractionStatusZod.optional(),
    agent: z.string(),
});
export type MarkersOfHarmMohUpdateRequestType = z.TypeOf<typeof MarkersOfHarmMohUpdateRequestZod>;

